<template>
    <div class="contentGlobal">
        <div class="listContainer">
            <div class="pTop">
                <b-form @submit.prevent="runQuery()">
                    <b-form-group  label-cols-sm="2" >
                        <b-row>
                            <b-col sm="2">
                                <label for="collectionSelect">Select database:</label>
                                <select id="collectionSelect" v-model="selectedCollection" class="form-control">
                                    <option value="pools">Pools</option>
                                    <option value="users">Users</option>
                                    <option value="logs">Logs</option>
                                </select>
                            </b-col>
                        <b-col sm="2">
                            <b-form-checkbox v-model="limitEnabled">Limit results</b-form-checkbox>
                            <b-form-input v-if="limitEnabled" type="number" class="form-control" v-model.number="resultLimit" placeholder="Límite" min="1"></b-form-input>
                        </b-col>
                        <b-form-checkbox v-model="isDark">Dark mode</b-form-checkbox>
                        </b-row>
                      
                    </b-form-group>
                    <b-form-group v-for="(clause, index) in clauses" :key="index" class="mb-3" label-cols-sm="2"
                        label-align-sm="right">
                        <b-row>
                            <!-- <b-col v-if="clauses.length > 1" sm="2">
                                <select v-model="clause.condition" class="form-control">
                                    <option value="AND">AND</option>
                                    <option value="OR">OR</option>
                                </select>
                            </b-col> -->

                            <b-col sm="2">
                                <b-form-input v-model="clause.field" placeholder="Field or property" required></b-form-input>
                            </b-col>
                            <b-col sm="2">
                                <select v-model="clause.operator" class="form-control" required>
                                    <option v-for="option in operators" :key="option.value" :value="option.value">{{option.text }}</option>
                                </select>
                            </b-col>
                            <b-col sm="2">
                                <select v-model="clause.type" class="form-control" required>
                                    <option v-for="option in types" :key="option.value" :value="option.value">{{option.text }}</option>
                                </select>
                            </b-col>
                            <b-col sm="4" v-if="clause.type !== 'null' && clause.type != 'boolean' && clause.type != 'date'" >
                                <b-form-input type="text" v-model="clause.value"
                                    :placeholder="getPlaceholder(clause.type)" required>
                                </b-form-input>
                            </b-col>
                        
                            <b-col v-else-if="clause.type === 'boolean'" sm="4">
                                <select v-model="clause.value" class="form-control">
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                                </select>
                            </b-col>

                            <b-col v-else-if="clause.type === 'date'" sm="4">
                                <b-form-datepicker v-if="clause.type === 'date'" v-model="clause.value" :placeholder="getPlaceholder(clause.type)" required></b-form-datepicker>     
                            </b-col>
                                
                           
                            <b-col sm="2" style="text-align: left;">
                                <b-button @click="addClause"><icon name="plus"></icon></b-button>
                                <b-button v-if="clauses.length > 1" @click="removeClause(index)" variant="danger"><icon name="trash"></icon></b-button>
                            </b-col>
                        </b-row>
                    </b-form-group>
                 
                    <b-form-group class="mb-3" label-cols-sm="2" label-align-sm="right">
                        <b-row>
                        <b-col sm="4">
                            <b-form-input v-model="orderBy.field" placeholder="Order by:"></b-form-input>
                        </b-col>
                        <b-col sm="4">
                            <select v-model="orderBy.direction" class="form-control">
                            <option value="asc">Ascendant</option>
                            <option value="desc">Descendant</option>
                            </select>
                        </b-col>
                        </b-row>
                    </b-form-group>
                    <b-button type="submit" variant="success" :disabled="isLoading"> Run Query</b-button>
                    <b-button style="float: right;" v-if="totalResults > 0" @click="exportData" variant="outline-primary">Export {{totalResults}} results</b-button>
                    <div class="mt-4">
                    <b-dropdown id="dropdown-1" text="Show/hide columns" class="m-md-2">
                        <b-dropdown-form>
                        <b-form-checkbox v-model="allColumnsSelected" @change="toggleAllColumns">
                            Select All  
                        </b-form-checkbox>
                        <b-form-checkbox-group v-model="visibleColumns" :options="columnOptions"></b-form-checkbox-group>
                        </b-dropdown-form>
                    </b-dropdown>
                </div>
                </b-form>
               
                <div class="table-responsive mt-4">
                    <b-table class="table-responsive " sticky-header="650px" head-variant="light" striped small bordered :dark="isDark" :items="formattedResults" :fields="visibleColumns">
                        <template v-if="selectedCollection=='pools'" #cell(id)="data">
                            <router-link  target= '_blank' :to="`/detail/${data.item.id}`" v-b-tooltip.hover title="Details">
                                {{ data.item.id }}
                            </router-link>
                        </template>
                        <template #cell(email)="data">
                            <router-link  target= '_blank' :to="`/user-detail/${data.item.id}`" v-b-tooltip.hover title="Details">
                                {{ data.item.email }}
                            </router-link>
                        </template>
                    
                    </b-table>
                </div>
                <div v-if="results.length" class="mt-3">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalResults"
                        :per-page="perPage"
                        @change="onPageChanged"
                        aria-controls="my-table"
                    ></b-pagination>
                    <p class="mt-2">Total results: {{ totalResults }}</p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
const fb = require('../firebaseConfig.js')

export default {
    name: 'Query',
    data() {
        return {
            isLoading: false,
            selectedCollection: 'pools', 
            clauses: [
                { field: '', operator: '==', type: 'string', value: '', condition: "AND" }
            ],
            orderBy:{
                field:null,
                direction: 'desc'
            },
            excludedColumns: [], 
            allColumnsSelected: true,
            results: [],
            isDark:false,
            lastVisible: null,
            firstVisible: null,
            pageSize: 30,
            hasPrevious: false,
            hasNext: false,
            limitEnabled: false,
            resultLimit: 10,
            totalResults: 0,
            currentPage:1,
            visibleColumns: ['actions'],
            operators: [
                { value: '==', text: '==' },
                { value: '!=', text: '!=' },
                { value: '<', text: '<' },
                { value: '>', text: '>' },
                { value: '<=', text: '<=' },
                { value: '>=', text: '>=' },
                { value: 'in', text: 'in' },
                { value: 'not-in', text: 'not-in' }
            ],
            types: [
                { value: 'string', text: 'string' },
                { value: 'boolean', text: 'boolean' },
                { value: 'number', text: 'number' },
                { value: 'date', text: 'Date' } ,
                { value: 'null', text: 'null' }
            ],
            tableFields: ['actions'],
            baseURL: 'https://europe-west1-hayward-europe.cloudfunctions.net/apiSearch',
            //baseURL: 'http://localhost:3000/search' 
        };
    },

    computed: {
        formattedResults() {
            return this.results.map(result => {
                let formattedResult = {};
                for (let key in result.data) {
                    
                    if (typeof result[key] === 'object' && result[key] !== null) {
                        formattedResult[key] = JSON.stringify(result.data[key]);
                    } else {
                        let _val = (key == 'ts' || key == 'createdAt' || key == 'updatedAt') ? this.formatDate(result.data[key]) : result.data[key];
                        formattedResult[key] = _val;
                    
                    
                    }
                }
                return formattedResult;
            });
        },
        columnOptions() {
            return this.tableFields.map(field => ({ text: field.label, value: field.key }));
         },
        visibleTableFields() {
            return this.tableFields.filter(field => !this.excludedColumns.includes(field.key));
        },
        perPage(){
            return this.limitEnabled ? this.resultLimit : this.pageSize
        }
    },
    watch: {
        visibleColumns(newVal) {
            this.allColumnsSelected = newVal.length === this.tableFields.filter(field => !this.excludedColumns.includes(field.key)).length;
        }
    },
    created() {
        // Initialize visibleColumns to show all columns except excluded ones
        this.visibleColumns = this.tableFields.filter(field => !this.excludedColumns.includes(field.key)).map(field => field.key);
        this.allColumnsSelected = this.visibleColumns.length === this.tableFields.filter(field => !this.excludedColumns.includes(field.key)).length;
    },
    methods: {
        toggleAllColumns() {
            if (!this.allColumnsSelected) {
                this.visibleColumns = this.tableFields.filter(field => !this.excludedColumns.includes(field.key)).map(field => field.key);
            } else {
                this.visibleColumns = [];
            }
        },
        formatDate(value) {
            let date;
            if (typeof value === 'number') {
                if (value > 10000000000) { 
                    date = this.$moment(value);
                } else {
                    date = this.$moment.unix(value);
                }
            } else {
                date = moment(value, true); 
            }

            if (date.isValid()) {
                return date.format("DD-MM-YYYY HH:mm:ss");
            } else {
                return "Invalid Date";
            }
        },
        addClause() {
            this.clauses.push({ field: '', operator: '==', type: 'string', value: '' });
        },
        removeClause(index) {
            this.clauses.splice(index, 1);
        },
        getPlaceholder(type) {
            switch (type) {
                case 'string':
                    return 'Value (string)';
                case 'boolean':
                    return 'Value (true/false)';
                case 'number':
                    return 'Value (number)';
                default:
                    return '';
            }
        },
        async runQuery() {
            this.isLoading = true;
            const response = await this.apiQuery(this.clauses, this.currentPage, this.pageSize);
            this.totalResults = (this.limitEnabled) ? this.resultLimit : response.totalRecords;
            if(this.totalResults > 0) {
                this.updateResults(response);
            }else{
                this.$snotify.async("", "", () => new Promise((resolve, reject) => {
                    this.isLoading = false;
                    resolve({
                        body: "No results found" ,
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }))
            }
           
        },
        async nextPage() {
            if (!this.hasNext) return;
            this.currentPage++;
            await this.runQuery();
        },
        async previousPage() {
            if (this.currentPage === 1) return;
            this.currentPage--;
            await this.runQuery();
        },

        async apiQuery(clauses, page, _limit) {
            const searchStatements = clauses.map(clause => ({
                combine: clause.condition,
                field: 'data' + '.' + clause.field,
                operator: clause.operator,
                type: (clause.type == 'date') ? 'number' : clause.type,
                value: (clause.type == 'date') ? this.$moment(clause.value).unix() : clause.value,
              
            }));

            return fb.auth.currentUser.getIdToken(true).then( async(idToken) => {
                let limit = this.limitEnabled ? this.resultLimit : _limit;
                let collection = this.selectedCollection;
                const config = {
                    method: 'post',
                    url: `${this.baseURL}`,
                    headers: {
                        'Authorization':  'Bearer '+idToken
                    },
                data: {
                    collection: collection,
                    searchStatements: searchStatements,
                    page: page,
                    limit: limit,
                    orderBy: (this.orderBy.field !='') ? 'data' + '.' + this.orderBy.field : '',
                    orderDirection: this.orderBy.direction
                    }
                };

                try {
                    const response = await axios(config);
                    return response.data;
                } catch (error) {
                    console.error('Error making API request:', error);
                }
            })
   
        },
        updateResults(data) {
            this.isLoading = false;
            this.results = data.results;
            this.hasPrevious = this.currentPage > 1;
            this.hasNext = data.results.length === this.pageSize;
            let _json = (this.results && this.results[0].data) ? this.results[0].data : {};
            let desiredOrder = []

            if(this.selectedCollection === "pools"){
                desiredOrder = ["id", "wifi","present","updatedAt","createdAt"];
            }else if(this.selectedCollection === "users"){
                desiredOrder = ["id", "email", "name","company", "pools", "language", "phone", "country","createdAt"];
            }else if(this.selectedCollection === "logs"){
                desiredOrder = ["ts", "poolId", "userId","op", "command"];
            }
          
            const orderedKeys = desiredOrder.concat(
                Object.keys(_json).filter(key => !desiredOrder.includes(key))
            );
         
            this.tableFields = orderedKeys.map(key => ({ key, label: key }));
            if (this.visibleColumns.length > 0) {
                this.visibleColumns = this.tableFields.map(field => field.key);
            }
            this.tableFields.push('actions');
  
        },
        exportData() {
            this.$snotify.async("Generating CSV file, please be patient", () => new Promise(async (resolve, reject) => {
                try {
                    const chunkSize = 2000;
                    const totalResults = this.totalResults; 
                    const numChunks = Math.ceil(totalResults / chunkSize);
                    let allResults = [];

                    for (let i = 0; i < numChunks; i++) {
                        const response = await this.apiQuery(this.clauses, i+1, chunkSize);
                        const csvData = await this.formatCSV(response);
                        allResults = allResults.concat(csvData);
                    }

                    const blob = new Blob([allResults], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'query_results_' + this.selectedCollection + '.csv');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    resolve({
                        body: "CSV created correctly",
                        config: {
                            timeout: 1500,
                            closeOnClick: true
                        }
                    });
                } catch (e) {
                    console.log(e);
                    reject({
                        body: "Your request cannot be completed, please try again or contact admin site",
                        config: {
                            timeout: 2500,
                            closeOnClick: true
                        }
                    });
                }
            }));
        },
        async formatCSV(data){
            const keys = Object.keys(data.results[0].data);
                    const csvData = [
                    keys.join(','), // header row
                    ...data.results.map(row => keys.map(k => {
                        let value = row.data[k];
                        if (typeof value === 'object' && value !== null) {
                            value = JSON.stringify(value);
                        }
                        return `"${value}"`; // Ensuring values are properly quoted
                    }).join(',')) // data rows
                ].join('\n');
                return csvData;
        },
        async onPageChanged(page) {
            this.currentPage = page;
            await this.runQuery();
        },
        goToDetails(id) {
            let route = (this.selectedCollection == 'pools') ? '/detail/' : '/user-detail/'
             let href = this.$router.push(route+id);
            window.open(route.href, '_blank');
        },
    }
};
</script>
<style>
.b-table th,
.b-table td {
  min-width: 150px; 
}

.b-table th,
.b-table td {
  text-align: left; 
}


.box {
    width: 98%;
    margin: 80px auto 0;
    display: flex;
    justify-content: center;

}

.tb{
    text-align: left;
}

.pTop {
    padding-top: 80px;
}

.table-responsive {
  max-height: 400px;
  overflow-y: auto;
}

.b-table {
  table-layout: auto;
}

.b-table th.sticky-column,
.b-table td.sticky-column {
  position: sticky;
  right: 0;
  background-color: white;
  z-index: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/Query-panel.vue